module.exports = __webpack_public_path__ + "img/PAMMAccountLogo4.08429f91.svg";